import { PersonDto } from '../../person/models/PersonDto'
import { FeedbackDto } from './FeedbackDto'
import {
    SharedWorkHistoryDto,
    SharedWorkHistoryLiteDto,
} from './SharedWorkHistoryDto'

export type CandidateConnectionDto = {
    connectedPerson: PersonDto // hiring manager or person that has given feedback about this candidate
    type: CandidateConnectionType
    sharedWorkHistory?: SharedWorkHistoryDto[] // will be undefined if the connected person has only given feedback
    feedback?: FeedbackDto // will be undefined if the connected person is a hiring manager that hasn't given feedback
    interviewForThisRole?: InterviewForThisRoleValues // will always be undefined if the connected person has only given feedback
}

export type CandidateConnectionLiteDto = {
    connectedPersonId: string
    sharedWorkHistory: SharedWorkHistoryLiteDto[]
    feedback?: FeedbackDto
    interviewForThisRole?: InterviewForThisRoleValues
}

export type CandidateCompanyConnectionLiteDto = {
    connectedCompanyId: string
}

export enum CandidateConnectionType {
    HIRING_MANAGER = 'HIRING_MANAGER',
    PERSON_WHO_GAVE_FEEDBACK = 'PERSON_WHO_GAVE_FEEDBACK',
    BOTH = 'BOTH',
}

export enum InterviewForThisRoleValues {
    YES = 'yes',
    NO = 'no',
}
